const contactRole = [
    { key: "DECISION_MAKER", value: "DECISION_MAKER" },
    { key: "INFLUENCER", value: "INFLUENCER" },
    { key: "NO_INFLUENCE", value: "NO_INFLUENCE" },
];

export { contactRole };